import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useMessagesScheme = () => {
  const { t } = useTranslation();
  const requiredError = t('errors.required');

  return yup.object({
    language: yup.string().required(requiredError),
    content: yup.string().max(275),
  });
};
